import type { KeyboardEvent, MouseEvent, PointerEvent } from 'react'
import { useCallback, useEffect, useRef } from 'react'

export function useLogoLongPress(onTrigger: () => void) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const startPoint = useRef({ x: 0, y: 0 })
  const cancel = useCallback(() => {
    if (timer.current !== null) clearTimeout(timer.current)
    timer.current = null
  }, [])

  useEffect(() => {
    window.addEventListener('blur', cancel)
    return () => {
      cancel()
      window.removeEventListener('blur', cancel)
    }
  }, [cancel])

  return {
    onPointerDown: (event: PointerEvent) => {
      if (!event.isPrimary || event.button !== 0) return
      cancel()
      startPoint.current = { x: event.clientX, y: event.clientY }
      timer.current = setTimeout(() => {
        cancel()
        onTrigger()
      }, 5000)
    },
    onPointerMove: (event: PointerEvent) => {
      if (Math.hypot(event.clientX - startPoint.current.x, event.clientY - startPoint.current.y) > 12) cancel()
    },
    onPointerUp: cancel,
    onPointerCancel: cancel,
    onPointerLeave: cancel,
    onLostPointerCapture: cancel,
    onContextMenu: (event: MouseEvent) => event.preventDefault(),
    onKeyDown: (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onTrigger()
      }
    },
  }
}
